import { RouteConstants } from "../constants";
import IRoute from "../models/route.interface";
import ChangePasswordPage from "../pages/ChangePasswordPage/ChangePasswordPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage/ForgotPasswordPage";
import LoginPage from "../pages/LoginPage/LoginPage";
import ResetPasswordPage from "../pages/ResetPasswordPage/ResetPasswordPage";

export const authRoutes: IRoute[] = [
  {
    id: RouteConstants.LOGIN,
    path: RouteConstants.LOGIN_PATH,
    component: <LoginPage />,
    appScopes: ["uniqueId"],
  },
  {
    id: RouteConstants.CHANGE_PASSWORD,
    path: RouteConstants.CHANGE_PASSWORD_PATH,
    component: <ChangePasswordPage />,
  },
  {
    id: RouteConstants.FORGOT_PASSWORD,
    path: RouteConstants.FORGOT_PASSWORD_PATH,
    component: <ForgotPasswordPage />,
  },
  {
    id: RouteConstants.RESET_PASSWORD,
    path: RouteConstants.RESET_PASSWORD_PATH,
    component: <ResetPasswordPage />,
  },
];
